// Importing necessary action type constants
import { CSCQ_SELECT_OPTION, CSCQ_SUBMIT } from '../../Redux.constants';

/**
 * CSCQReducerNew
 * A reducer function to manage the state related to CSCQ (Single Choice Single Question) components.
 * 
 * @param {object} state - Represents the current state of the CSCQ components. Each key in the state object is a component's ID.
 * @param {object} action - Represents the dispatched action.
 * @returns {object} - Returns the new state based on the action.
 */
export function CSCQReducerNew(state = {}, action) {
  switch (action.type) {
    // If a CSCQ option is selected, update the state to reflect the selected option for the given component.
    case CSCQ_SELECT_OPTION:
      return {
        ...state,
        [action.payload.componentID]: {
          ...state[action.payload.componentID],
          selected: action.payload.optionID
        }
      }
    // When the CSCQ component is submitted, update the disabled list with the currently selected option (if present).
    case CSCQ_SUBMIT: {
      const componentID = action.payload;
      const currentComponentState = state[componentID] || {};

      const selectedOption = currentComponentState.selected;

      let disabledList = currentComponentState.disabled || [];
      if (selectedOption !== undefined) {
        disabledList = [...disabledList, selectedOption];
      }

      return {
        ...state,
        [componentID]: {
          disabled: disabledList
        }
      };
    }
    // For any other action, simply return the current state.
    default:
      return state;
  }
}
